import { useState, useCallback } from 'react';

interface UseRecallSessionProps {
  isReviewMode: boolean;
  isDue: boolean;
  isAuthenticated: boolean;
}

export function useRecallSession({
  isReviewMode,
  isDue,
  isAuthenticated,
}: UseRecallSessionProps) {
  const [userRevealed, setUserRevealed] = useState(false);

  const reveal = useCallback(() => setUserRevealed(true), []);

  const isContentVisible = !(
    isReviewMode &&
    isAuthenticated &&
    isDue &&
    !userRevealed
  );
  const isRatingVisible = isReviewMode && isAuthenticated && isContentVisible;

  return { isContentVisible, isRatingVisible, reveal };
}
